import Cookies from 'js-cookie'
const state = {
  projectName: "", // 存储当前申请系统数据 -- 中文
  projectCode: "", // 存储当前申请系统数据 -- 英文
  isDisplay: false,
  detailsUrl: ''
};

const mutations = {
  SET_PROJECTNAME: (state, projectName) => {
    state.projectName = projectName;
    Cookies.set('projectName', projectName)
  },
  SET_PROJECTCODE: (state, projectCode) => {
    state.projectCode = projectCode;
    Cookies.set('projectCode', projectCode)
  },
  SET_DETAILSURL: (state, detailsUrl) => {
    state.detailsUrl = detailsUrl;
    Cookies.set('detailsUrl', detailsUrl)
  },
  SET_ISDISPLAY: (state, isDisplay) => {
    state.isDisplay = isDisplay;
  }
};

const actions = {
  
};

export default {
  state,
  mutations,
  actions,
};
